import React from 'react';
import styles from './LogoMicrosoft.module.scss';
import { ReactComponent as Logo } from '../../../Images/logo-microsoft.svg';

export const LogoMicrosoft = (): React.ReactElement<{}> => {
  return (
    <div className={styles.logoMicrosoft}>
      <Logo />
    </div>
  );
};
